import styled from 'styled-components'

export const StyledWrapper = styled.div`
  grid-row-start: 3;
  grid-column-start: 2;
`
